
document
  .querySelectorAll('.open-cookie-consent')
  .forEach(link => {
    link.addEventListener('click', () => {
      document.dispatchEvent(new Event('cookie_consent_details_show'))
    })
  })

function loadVideos(event) {
  const acceptedCategories = event?.detail?.acceptedCategories;


  if (acceptedCategories.includes("youtube")) {
    document
      .querySelectorAll('[data-requires-consent=youtube]')
      .forEach(enableIframe)
  }
  if (acceptedCategories.includes("vimeo")) {
    document
      .querySelectorAll('[data-requires-consent=vimeo]')
      .forEach(enableIframe)
  }
}

function enableIframe(iframe) {
  iframe.setAttribute('src', iframe.getAttribute('data-src'))
  iframe.setAttribute('width', iframe.getAttribute('data-width'))
  iframe.setAttribute('height', iframe.getAttribute('data-height'))
  iframe.nextElementSibling.remove()
}

// window.dataLayer = window.dataLayer || [];
// function gtag() {
//   dataLayer.push(arguments);
// }
// gtag("js", new Date());

// gtag("config", "ENTERID");

// function loadAnalyticsScript() {
//   // Add Script only once
//   const scriptElementExists = document.querySelector("[data-scriptid='ga']");
//   if (scriptElementExists || window?.ga) return;

//   const firstScriptElement = document.getElementsByTagName("script")[0];

//   const scriptElement = document.createElement("script");
//   scriptElement.type = "text/javascript";
//   scriptElement.setAttribute("async", "true");
//   scriptElement.setAttribute(
//     "src",
//     "https://www.googletagmanager.com/gtag/js?id=ENTERID"
//   );
//   scriptElement.setAttribute("data-scriptid", "ga");

//   // firstScriptElement.parentNode.insertBefore(
//   //   scriptElement,
//   //   firstScriptElement
//   // );
//   console.log('LOAD GA')
// }
// // =========================================================================
// // COOKIE CONSENT: LOAD SCRIPTS AFTER USER INTERACTION
// // =========================================================================
// function loadScripts(event) {
//   const acceptedCategories = event?.detail?.acceptedCategories;

//   if (acceptedCategories.includes("analytics")) {
//     console.log("Analytics accepted.");

//     loadAnalyticsScript();
//   }
//   if (acceptedCategories.includes("marketing")) {
//     console.log("Marketing accepted.");
//   }
// }

// window.addEventListener("cookie_consent_preferences_restored", loadScripts);
// window.addEventListener("cookie_consent_preferences_updated", loadScripts);
window.addEventListener("cookie_consent_preferences_restored", loadVideos);
window.addEventListener("cookie_consent_preferences_updated", loadVideos);